export const SAVE_ARTICLE = 'SAVE_ARTICLE';
export const SAVE_ARTICLE_SUCCESS = 'SAVE_ARTICLE_SUCCESS';
export const SAVE_ARTICLE_FAILURE = 'SAVE_ARTICLE_FAILURE';
export const ADD_ARTICLE_TO_THE_LIST = 'ADD_ARTICLE_TO_THE_LIST';
export const UPDATE_ARTICLE_IN_THE_LIST = 'UPDATE_ARTICLE_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/ArticleForm/actionTypes.js